import { Close } from "@mui/icons-material";
import { Box, Button, IconButton, Stack, TextField } from "@mui/material"
import { useState } from "react";

interface AddProductFieldProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    onRemove: () => void;
}

export const AddProductField = ({ label, value, onChange, onRemove }: AddProductFieldProps) => {
    const [showField, setShowField] = useState(false);

    const handleRemove = () => {
        setShowField(false);
        onRemove();
    };

    return (
        <Box >
            {showField ? (
                <Stack direction="row" spacing={1} alignItems="center">
                    <TextField
                        autoFocus
                        label={label}
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        fullWidth
                        size="small"
                        sx={{ width: '200px' }}
                    />
                    <IconButton size="small" onClick={() => setShowField(false)}>
                        <Close />
                    </IconButton>
                </Stack>
            ) : (
                <Button variant="contained" color="info" onClick={() => setShowField(true)}>{label}</Button>
            )}
        </Box>
    );
}   